import React from "react";
import { Navigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { canAccessQrScanner } from "../../Helpers";
import QrScannerLanding from "./index";

// Gate the /qr-scanner-landing route: the Vuse survey is only available to
// consumers with no brands yet or who have opted into "vuse". glo-only
// consumers are redirected to the not-found page.
export default function QrScannerRoute() {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["user-details"]) ?? {};

  if (!canAccessQrScanner(data?.consumer?.brands)) {
    return <Navigate to="/404" replace />;
  }

  return <QrScannerLanding />;
}
